module.exports = __webpack_public_path__ + "static/media/placeholder.e2c78554.svg";